import React, { useEffect } from "react";
import "./EditTitleModal.scss";
import { Col, Form, Input, Modal, Row } from "antd";
import { formValidation } from "../../../../../utils/formValidation";

interface IEditTitleModal {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  currentTitle: string;
  onSubmit?: (values: any, afterSubmit?: () => void) => void;
  loading?: boolean;
}

export const EditTitleModal: React.FC<IEditTitleModal> = ({
  modalOpen,
  setModalOpen,
  currentTitle,
  onSubmit,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!modalOpen) {
      form.resetFields();
    }
  }, [form, modalOpen]);

  useEffect(() => {
    if (modalOpen) {
      form.setFieldsValue({
        title: currentTitle,
      });
    }
  }, [currentTitle, modalOpen]);

  const handleSubmit = (values: any) => {
    onSubmit?.(values, () => setModalOpen(false));
  };

  return (
    <Modal
      open={modalOpen}
      className={"edit-title-modal"}
      title={"სათაურის რედაქტირება"}
      onOk={form.submit}
      okText={"დასტური"}
      cancelText={"დახურვა"}
      onCancel={() => setModalOpen(false)}
      maskClosable
      destroyOnClose
      centered
      okButtonProps={{
        loading: loading,
      }}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Row>
          <Col span={24}>
            <Form.Item name={"title"} rules={formValidation.required}>
              <Input className={"edit-task-input"} placeholder={"სათაური"} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
